<template>
  <el-dialog
    :title="popupName"
    :visible="is_visible"
    :close-on-click-modal="false"
    width="480px"
    @close="cancelCallback"
    class="dialog"
  >
    <div>
      <p class="dialog__text">
        За генерацию результатов прохождения на стороне SHL будут списаны
        балансовые единицы. Получить результаты по выбранному инструменту?
      </p>
    </div>
    <div slot="footer">
      <div class="footer">
        <Button
          buttonSize="big"
          buttonColor="transparent"
          buttonText="Отменить"
          @click="cancelCallback"
          class="footer__button-cancel"
        />
        <Button
          buttonSize="big"
          buttonColor="blue"
          :disabled="loading"
          :loading="loading"
          buttonText="Получить результаты"
          class="footer__button-ok"
          @click.prevent="surveyResult"
        />
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { eventBus } from '@/bus';
import { getController } from '@/controllers/request';
import { EVENTBUS_EVENTS, SUBPANEL } from '@/utils/constants';
import { errorMsg, mixin } from '@/utils/mixins';
import { Dialog } from 'element-ui';
import Button from 'Elements/Button/Button';
export default {
  mixins: [mixin, errorMsg],
  data() {
    return {
      loading: false
    };
  },
  props: {
    is_visible: Boolean,
    rowData: Object
  },
  computed: {
    popupName() {
      return `Получить результаты ${
        this.rowData?.name?.value ? `по ${this.rowData.name.value}` : ''
      }`;
    }
  },
  methods: {
    async surveyResult() {
      this.loading = true;
      const params = {
        action: 'get_shl_test_results',
        module: 'HRPAC_SURVEY_QUESTIONNAIRE',
        record: this.rowData.id.value,
        to_pdf: true,
        jsqon_return: 1
      };
      const response = await getController({ params });

      if (response.data.button && response.data.button.length) {
        this.showNotificationWithLinks({
          offset: 100,
          showClose: true,
          title: response.data.title || '',
          message: response.data.message,
          type: response.data.status,
          button: response.data?.button
        });
      } else {
        this.showNotification({
          offset: 100,
          showClose: true,
          message: response.data.message,
          type: response.data.status
        });
      }

      if (response.data && response.data.status === 'success') {
        eventBus.$emit(
          EVENTBUS_EVENTS.RELOAD_TAB,
          SUBPANEL.ID.SURVEY_QUESTIONNAIRE
        );
      }
      this.loading = false;
      this.cancelCallback();
    },
    cancelCallback() {
      this.$emit('reset-callback');
    }
  },
  components: {
    'el-dialog': Dialog,
    Button
  }
};
</script>
<style lang="scss" scoped>
#front .dialog {
  & ::v-deep .el-dialog__title {
    margin-bottom: 20px;
  }

  &__text {
    margin-top: 0;
  }
}
</style>
